import { render, staticRenderFns } from "./PartnerVerticalNavMenuGroup.vue?vue&type=template&id=09c866d2"
import script from "./PartnerVerticalNavMenuGroup.vue?vue&type=script&lang=js"
export * from "./PartnerVerticalNavMenuGroup.vue?vue&type=script&lang=js"
import style0 from "./PartnerVerticalNavMenuGroup.vue?vue&type=style&index=0&id=09c866d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports